import * as types from './constants'

export const showGenericMessage = message => ({
  type: types.SHOW_GENERIC_MESSAGE,
  payload: message
})

export const hideGenericMessage = () => ({
  type: types.HIDE_GENERIC_MESSAGE
})

export const setUrlRedirect = (url) => ({
  type: types.SET_URL_REDIRECT,
  payload: url
})
